// extracted by mini-css-extract-plugin
export var divider = "_ua-0";
export var systemMessage = "_ua-1";